import type { FC } from 'react';
import type { WebhookProviderConfigViewProps } from '../types';
import { EmailWebhookConfigView } from './email-webhook-config-view';
import { HubspotWebhookConfigView } from './hubspot-webhook-config-view';

export const CUSTOM_WEBHOOK_PROVIDER_CONFIG_VIEWS = {
  email: EmailWebhookConfigView,
  hubspot: HubspotWebhookConfigView,
} satisfies Partial<
  Record<
    WebhookProviderConfigViewProps['catalog']['key'],
    FC<WebhookProviderConfigViewProps>
  >
>;

export { DefaultWebhookProviderConfigView } from './default-webhook-provider-config-view';
